var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 7.66659L9.99984 1.83325M9.99984 1.83325L15.8332 7.66659M9.99984 1.83325V9.41659",
    stroke: "#0D9C7A",
    strokeWidth: 2.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83317 11.1666V15.25C8.83317 15.5594 8.95609 15.8561 9.17488 16.0749C9.39367 16.2937 9.69042 16.4166 9.99984 16.4166C10.3093 16.4166 10.606 16.2937 10.8248 16.0749C11.0436 15.8561 11.1665 15.5594 11.1665 15.25V11.1666H16.9998C17.6187 11.1666 18.2122 11.4125 18.6497 11.85C19.0873 12.2876 19.3332 12.8811 19.3332 13.5V18.1666C19.3332 18.7855 19.0873 19.379 18.6497 19.8165C18.2122 20.2541 17.6187 20.5 16.9998 20.5H2.99984C2.381 20.5 1.78751 20.2541 1.34992 19.8165C0.912336 19.379 0.666504 18.7855 0.666504 18.1666V13.5C0.666504 12.8811 0.912336 12.2876 1.34992 11.85C1.78751 11.4125 2.381 11.1666 2.99984 11.1666H8.83317Z",
    fill: "#0D9C7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportReportIcon);
export default __webpack_public_path__ + "static/media/exportReportIcon.505f5cd3c8fc68c980470fc928cf8666.svg";
export { ForwardRef as ReactComponent };